module.exports = __webpack_public_path__ + "static/media/ziplogo.00506171.png";